import { render, staticRenderFns } from "./CrazySurprise.vue?vue&type=template&id=54d558d1&"
import script from "./CrazySurprise.vue?vue&type=script&lang=js&"
export * from "./CrazySurprise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports